import { respnse as sandboxResponse } from './sandbox/product-variant-metafield-cache';
import { respnse as productionRespnse } from './production/product-variant-metafield-cache';

// Vite replaces import.meta.env.MODE at build time and tree-shakes the unused branch,
// so only the relevant cache is included in the final bundle.
export const respnse = import.meta.env.MODE === 'production'
  ? productionRespnse
  : sandboxResponse;
